/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, PageGridContainer, Typography } from '@coursera/cds-core';

import LeftConfetti from 'bundles/enterprise-admin-program-creation/components/svg/LeftConfetti';
import RightConfetti from 'bundles/enterprise-admin-program-creation/components/svg/RightConfetti';

export const Banner: React.FC<{
  title: React.ReactNode;
  withConfetti?: boolean;
  withTheContractPageWorkaround?: boolean;
}> = ({ title, withConfetti, withTheContractPageWorkaround }) => {
  const children = (
    <Typography variant="d2semibold" color="invertBody">
      {title}
    </Typography>
  );
  return (
    <section
      css={{
        height: '251px',
        paddingTop: 'var(--cds-spacing-600)',
        background: 'var(--cds-color-blue-700)',
        position: 'relative',
      }}
      aria-hidden={true}
    >
      {withConfetti && <LeftConfetti css={{ position: 'absolute', top: 0, left: 0 }} />}
      {withConfetti && <RightConfetti css={{ position: 'absolute', top: 0, right: 0 }} />}
      <PageGridContainer maxWidth="lg" css={{ position: 'relative', zIndex: 1 }}>
        {withTheContractPageWorkaround ? (
          <Grid container justifyContent="center">
            <div
              css={{
                width: '1013px' /* this is the width of the contracts table */,
                boxSizing: 'content-box',
              }}
            >
              {children}
            </div>
          </Grid>
        ) : (
          <Grid item>{children}</Grid>
        )}
      </PageGridContainer>
    </section>
  );
};
